import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CameraConnection from 'src/models/Camera/CameraConnection';
import { CameraData } from 'src/models/CameraData.model';

import { captureError } from 'src/utils/errorReporting';

export const getCameraDataWithRefreshedGains = async (): Promise<
  CameraData | undefined
> => {
  const { cameraData, setCameraData } = useRemoteBoundStore.getState();
  if (!cameraData) {
    return undefined;
  }

  try {
    const { sideGain, mainGain } =
      await CameraConnection.getInstance().getGain();

    const refreshed: CameraData = {
      ...cameraData,
      sideGain,
      mainGain,
    };
    setCameraData(refreshed);
    return refreshed;
  } catch (error) {
    captureError(error, 'Failed to get camera data');
    return cameraData;
  }
};
